// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.our-mission-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.our-mission-section .our-mission-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.our-mission-section .our-mission-wrap .our-mission-box .our-mission-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}
.our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box {
  width: 100%;
  max-width: 50rem;
  background-color: var(--secondaryMain-1000);
  border-radius: 2rem;
  box-shadow: 0px 4px 4px var(--black-250);
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.25rem;
  padding: 2rem 1.25rem;
}
.our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box .list-text-box {
  padding-left: 1.75rem;
}
.our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box .list-text-box .list-text {
  color: var(--black-1000);
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.4;
}
.our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box .list-text-box .list-text:not(:last-child) {
  margin-bottom: 1.5rem;
}
.our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .img-box {
  width: 100%;
  max-width: 38.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .img-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
.our-mission-section .our-mission-wrap .our-mission-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
@media screen and (max-width: 991.98px) {
  .our-mission-section {
    padding: 2.5rem 0;
    margin: 0 auto;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box {
    border-radius: 1.5rem;
    padding: 1.5rem 1.25rem;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box .list-text-box {
    padding-left: 1.25rem;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box .list-text-box .list-text {
    font-size: 1rem;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box .list-text-box .list-text:not(:last-child) {
    margin-bottom: 1rem;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .img-box {
    max-width: 12rem;
    display: none;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .btn-box {
    margin-top: 2.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .our-mission-section {
    padding: 2rem 0;
    margin: 0 auto;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box {
    border-radius: 1rem;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box .list-text-box {
    padding-left: 1.25rem;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box .list-text-box .list-text {
    font-size: 0.875rem;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box .list-text-box .list-text:not(:last-child) {
    margin-bottom: 0.75rem;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .img-box {
    max-width: 9rem;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .btn-box {
    margin-top: 1.25rem;
  }
}
@media screen and (max-width: 639.98px) {
  .our-mission-section {
    padding: 2rem 0;
    margin: 0 auto;
  }
  .our-mission-section .our-mission-wrap .our-mission-box .our-mission-container .text-box {
    grid-template-columns: repeat(1, 1fr);
    gap: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/OurMissionSection/OurMissionStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAAR;AAEQ;EACE,WAAA;EACA,gBAAA;EACA,2CAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,qCAAA;EACA,YAAA;EACA,qBAAA;AAAV;AAEU;EACE,qBAAA;AAAZ;AAEY;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAAd;AAEc;EACE,qBAAA;AAAhB;AAMQ;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJV;AAMU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAJZ;AASM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAPR;AAYE;EApEF;IAqEI,iBAAA;IACA,cAAA;EATF;EAcQ;IACE,qBAAA;IACA,uBAAA;EAZV;EAcU;IACE,qBAAA;EAZZ;EAcY;IACE,eAAA;EAZd;EAcc;IACE,mBAAA;EAZhB;EAkBQ;IACE,gBAAA;IACA,aAAA;EAhBV;EAoBM;IACE,kBAAA;EAlBR;AACF;AAuBE;EAzGF;IA0GI,eAAA;IACA,cAAA;EApBF;EAyBQ;IACE,mBAAA;EAvBV;EAyBU;IACE,qBAAA;EAvBZ;EAyBY;IACE,mBAAA;EAvBd;EAyBc;IACE,sBAAA;EAvBhB;EA6BQ;IACE,eAAA;EA3BV;EA+BM;IACE,mBAAA;EA7BR;AACF;AAkCE;EA5IF;IA6II,eAAA;IACA,cAAA;EA/BF;EAoCQ;IACE,qCAAA;IACA,YAAA;EAlCV;AACF","sourcesContent":[".our-mission-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .our-mission-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .our-mission-box {\n      .our-mission-container {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        gap: 0.5rem;\n        position: relative;\n\n        .text-box {\n          width: 100%;\n          max-width: 50rem;\n          background-color: var(--secondaryMain-1000);\n          border-radius: 2rem;\n          box-shadow: 0px 4px 4px var(--black-250);\n          display: grid;\n          grid-template-columns: repeat(1, 1fr);\n          gap: 1.25rem;\n          padding: 2rem 1.25rem;\n\n          .list-text-box {\n            padding-left: 1.75rem;\n\n            .list-text {\n              color: var(--black-1000);\n              font-size: 1.25rem;\n              font-weight: 700;\n              line-height: 1.4;\n\n              &:not(:last-child) {\n                margin-bottom: 1.5rem;\n              }\n            }\n          }\n        }\n\n        .img-box {\n          width: 100%;\n          max-width: 38.75rem;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: contain;\n            object-position: center;\n          }\n        }\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n    margin: 0 auto;\n\n    .our-mission-wrap {\n      .our-mission-box {\n        .our-mission-container {\n          .text-box {\n            border-radius: 1.5rem;\n            padding: 1.5rem 1.25rem;\n\n            .list-text-box {\n              padding-left: 1.25rem;\n\n              .list-text {\n                font-size: 1rem;\n\n                &:not(:last-child) {\n                  margin-bottom: 1rem;\n                }\n              }\n            }\n          }\n\n          .img-box {\n            max-width: 12rem;\n            display: none;\n          }\n        }\n\n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n    margin: 0 auto;\n\n    .our-mission-wrap {\n      .our-mission-box {\n        .our-mission-container {\n          .text-box {\n            border-radius: 1rem;\n\n            .list-text-box {\n              padding-left: 1.25rem;\n\n              .list-text {\n                font-size: 0.875rem;\n\n                &:not(:last-child) {\n                  margin-bottom: 0.75rem;\n                }\n              }\n            }\n          }\n\n          .img-box {\n            max-width: 9rem;\n          }\n        }\n\n        .btn-box {\n          margin-top: 1.25rem;\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n    margin: 0 auto;\n\n    .our-mission-wrap {\n      .our-mission-box {\n        .our-mission-container {\n          .text-box {\n            grid-template-columns: repeat(1, 1fr);\n            gap: 0.75rem;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
